import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=609f4be8&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=609f4be8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609f4be8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('609f4be8')) {
      api.createRecord('609f4be8', component.options)
    } else {
      api.reload('609f4be8', component.options)
    }
    module.hot.accept("./AppFooter.vue?vue&type=template&id=609f4be8&scoped=true", function () {
      api.rerender('609f4be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AppFooter.vue"
export default component.exports